<template>
  <div class="w-full gap-4 p-4 flex items-center border-b border-gray-200">
    <div class="w-full flex max-w-7xl mx-auto">
      <div class="flex flex-1 justify-start">
        <BaseLogo />
      </div>

      <div
        v-if="isLanding"
        class="gap-4 sm:gap-12 flex-1 items-center justify-center hidden sm:flex"
      >
        <span
          class="hover:underline cursor-pointer"
          @click="() => $emit('scroll-to-section', 'demo')"
        >
          {{ $t('landing.header.demo') }}
        </span>
        <span
          class="hover:underline cursor-pointer"
          @click="() => $emit('scroll-to-section', 'faq')"
        >
          {{ $t('landing.header.faq') }}
        </span>
        <span
          class="hover:underline cursor-pointer"
          @click="() => $emit('scroll-to-section', 'pricing')"
        >
          {{ $t('landing.header.pricing') }}
        </span>
      </div>

      <div class="gap-4 flex-1 items-center justify-end hidden sm:flex">
        <template v-if="isAuthorized">
          <BasePopover>
            <template #toggler>
              <div class="gap-2 flex items-center cursor-pointer">
                <BaseAvatar class="cursor-pointer" :name="user.name" />
                <span class="text-sm hidden sm:block">{{ user.name }}</span>
              </div>
            </template>

            <template #content>
              <div
                class="mt-4 px-2 py-2 gap-2 flex flex-col bg-white rounded-lg shadow-lg"
              >
                <template v-for="(item, index) in popoverItems">
                  <div
                    v-if="item.type === 'divider'"
                    :key="`divider-${index}`"
                    class="h-px bg-gray-200"
                  />
                  <div
                    v-else
                    :key="`item-${index}`"
                    class="gap-4 px-4 py-2 flex items-center text-xl rounded-md cursor-pointer hover:bg-capino-light"
                    @click="item.handler"
                  >
                    <BaseIcon class="text-gray-500" :icon="item.icon" />
                    <span class="whitespace-nowrap">{{ item.text }}</span>
                  </div>
                </template>
              </div>
            </template>
          </BasePopover>
        </template>

        <div v-if="!isAuthorized" class="gap-4 flex items-center">
          <BaseButton size="extra-small" color="light" :to="{ name: 'signin' }">
            {{ $t('landing.header.logIn') }}
          </BaseButton>
        </div>
      </div>

      <div class="p-2 sm:hidden cursor-pointer" @click="isMenuVisible = true">
        <BaseIcon class="text-2xl" icon="menu-burger" />
      </div>
    </div>

    <BaseTopMenu v-if="isMenuVisible" ref="menu" @close="isMenuVisible = false">
      <div class="flex flex-col text-center">
        <div
          class="p-4 cursor-pointer hover:underline"
          @click="() => handleMenuClick('demo')"
        >
          <span>{{ $t('landing.header.demo') }}</span>
        </div>
        <div
          class="p-4 cursor-pointer hover:underline"
          @click="() => handleMenuClick('faq')"
        >
          <span>{{ $t('landing.header.faq') }}</span>
        </div>
        <div
          class="p-4 cursor-pointer hover:underline"
          @click="() => handleMenuClick('pricing')"
        >
          <span>{{ $t('landing.header.pricing') }}</span>
        </div>

        <div class="p-4">
          <BaseButton size="extra-small" color="light" :to="{ name: 'signin' }">
            {{ $t('landing.header.logIn') }}
          </BaseButton>
        </div>
      </div>
    </BaseTopMenu>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'

import BaseIcon from '@/components/Base/BaseIcon.vue'
import BaseAvatar from '@/components/Base/BaseAvatar.vue'
import BaseLogo from '@/components/Base/BaseLogo.vue'
import BasePopover from '@/components/Base/BasePopover.vue'
import BaseButton from '@/components/Base/BaseButton.vue'

import BaseTopMenu from '@/components/Base/BaseTopMenu.vue'

export default {
  name: 'LandingHeader',

  components: {
    BaseIcon,
    BaseAvatar,
    BaseLogo,
    BasePopover,
    BaseButton,
    BaseTopMenu
  },

  data: () => ({
    isMenuVisible: false
  }),

  computed: {
    ...mapState('user', ['user']),
    ...mapGetters('auth', ['isAuthorized']),

    isLanding() {
      return this.$route?.name === 'home'
    },

    popoverItems() {
      return [
        this.user.isPremium && {
          type: 'item',
          icon: 'rocket-lunch',
          text: this.$t('landing.welcomeHeader.goToTests'),
          handler: () => this.$router.push({ name: 'hub.sections' })
        },
        this.user.isPremium && {
          type: 'item',
          icon: 'time-past',
          text: this.$t('hub.sidebar.paymentHistory'),
          handler: () => this.$router.push({ name: 'hub.payment-history' })
        },
        this.user.isPremium && {
          type: 'divider'
        },
        this.isAuthorized &&
          !this.user.isPremium && {
            type: 'item',
            icon: 'rocket-lunch',
            text: this.$t('landing.welcomeHeader.goToTests'),
            handler: () => {
              this.$router.push({ name: 'onboarding' })
            }
          },
        {
          type: 'item',
          icon: 'sign-out-alt',
          text: this.$t('landing.welcomeHeader.logout'),
          handler: this.logout
        }
      ].filter(Boolean)
    }
  },

  methods: {
    ...mapActions('auth', {
      logout: 'LOGOUT'
    }),
    // ...mapMutations('ui', {
    //   setUiNewPaywallModalIsVisible: 'SET_UI_NEW_PAYWALL_MODAL_IS_VISIBLE'
    // }),

    handleMenuClick(section) {
      this.$refs.menu.handleClose()

      this.$emit('scroll-to-section', section)
    }
  }
}
</script>
